import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { loadStyles } from '../../utils/utils';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('i18nextLng', lng);
    document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
    loadStyles(lng);

    // Optionally clear local storage if needed
    localStorage.removeItem('simulationOption');
    localStorage.removeItem('personalityQuizState');
    localStorage.removeItem('quizData');
    localStorage.removeItem('quizState');
    localStorage.removeItem('skillsState');
    localStorage.removeItem('filterMajor');
    localStorage.removeItem('requiredSubjects');
    localStorage.removeItem('requiredSubjectsCompleted');
    localStorage.removeItem('suitableMajors');

    window.location.reload(); // Reload to apply changes
  };

  useEffect(() => {
    const currentLanguage = localStorage.getItem('i18nextLng') || 'en';
    loadStyles(currentLanguage);
    document.documentElement.dir = currentLanguage === 'ar' ? 'rtl' : 'ltr';

    const handleLanguageChange = (language) => {
      loadStyles(language);
      document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
    };

    i18n.on('languageChanged', handleLanguageChange);

    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, [i18n]);

  // Determine the displayed language text based on the current language
  const displayedLanguage = i18n.language === 'ar' ? 'English' : 'العربية';

  // Inline pill styles
  const pillStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    padding: '10px 14px',
    borderRadius: '9999px',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: 1,
    cursor: 'pointer',
    userSelect: 'none',

    // modern soft/glassy look
    background:
      'linear-gradient(180deg, rgba(255,255,255,.92), rgba(245,246,250,.88))',
    border: '1px solid rgba(0,0,0,.08)',
    boxShadow: '0 1px 2px rgba(0,0,0,.06), 0 8px 24px rgba(0,0,0,.05)',
    backdropFilter: 'saturate(140%) blur(6px)',
    WebkitBackdropFilter: 'saturate(140%) blur(6px)',

    transition:
      'transform .18s ease, box-shadow .18s ease, background-color .18s ease, border-color .18s ease',
  };

  return (
    <div
      className="language-display"
      style={pillStyle}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-1px)';
        e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,.12)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow =
          '0 1px 2px rgba(0,0,0,.06), 0 8px 24px rgba(0,0,0,.05)';
      }}
      onClick={() => changeLanguage(i18n.language === 'ar' ? 'en' : 'ar')}
    >
      {displayedLanguage}
    </div>
  );
};

export default LanguageSwitcher;
